export const PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY = "agency";
export const PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND = "brand";

export const SHARED_FIELD_KEYS = [
  "fullName",
  "email",
  "businessName",
  "jobTitle",
  "whatsApp",
  "websiteUrl",
];

export const BRAND_ONLY_FIELD_KEYS = [
  "whatYouSell",
  "averagePrice",
  "idealCustomer",
  "whereCustomerBuys",
  "hasAds",
  "adPlatforms",
  "monthlyAdSpend",
  "currentMetrics",
  "targetCpa",
  "bestCampaignMessages",
  "monthlySales",
  "salesGoal60to90",
  "buzzlyFocus",
  "creativeMaterialLevel",
  "creativeMaterialLocation",
  "additionalMeetingNotes",
  "meetingAccess",
  "accessNotReady",
];

export const AGENCY_ONLY_FIELD_KEYS = [
  "activeBrandsCount",
  "platformUsersCount",
  "agencyAdPlatforms",
  "sessionBrandName",
  "brandAssetsReady",
  "creativeBottleneck",
  "usesAdAutomation",
  "hasMetaBmAdminAccess",
];

export const sharedDefaultValues = {
  fullName: "",
  email: "",
  businessName: "",
  jobTitle: "",
  whatsApp: "",
  websiteUrl: "",
};

export const brandDefaultValues = {
  whatYouSell: "",
  averagePrice: "",
  idealCustomer: "",
  whereCustomerBuys: [],
  hasAds: "",
  adPlatforms: [],
  monthlyAdSpend: "",
  currentMetrics: "",
  targetCpa: "",
  bestCampaignMessages: "",
  monthlySales: "",
  salesGoal60to90: "",
  buzzlyFocus: "",
  creativeMaterialLevel: "",
  creativeMaterialLocation: "",
  additionalMeetingNotes: "",
  meetingAccess: [],
  accessNotReady: "",
};

export const agencyDefaultValues = {
  activeBrandsCount: "",
  platformUsersCount: "",
  agencyAdPlatforms: [],
  sessionBrandName: "",
  brandAssetsReady: "",
  creativeBottleneck: "",
  usesAdAutomation: "",
  hasMetaBmAdminAccess: "",
};

export const defaultFormValues = {
  organizationType: PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY,
  ...sharedDefaultValues,
  ...brandDefaultValues,
  ...agencyDefaultValues,
};

export const getOrganizationTypeFromRecord = (raw = {}) => {
  if (raw.organizationType === PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY) {
    return PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY;
  }
  return PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND;
};

const pickFields = ({ source = {}, keys = [] }) =>
  keys.reduce((acc, key) => {
    acc[key] = source[key] ?? defaultFormValues[key];
    return acc;
  }, {});

export const buildFormValuesForOrganizationType = ({
  organizationType,
  currentValues = {},
}) => {
  const sharedValues = pickFields({
    source: currentValues,
    keys: SHARED_FIELD_KEYS,
  });

  if (organizationType === PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY) {
    return {
      ...defaultFormValues,
      ...sharedValues,
      ...agencyDefaultValues,
      organizationType: PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY,
    };
  }

  return {
    ...defaultFormValues,
    ...sharedValues,
    ...brandDefaultValues,
    organizationType: PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND,
  };
};

export const sanitizePreActivationSubmitValues = (values = {}) => {
  const organizationType = getOrganizationTypeFromRecord(values);
  const sharedValues = pickFields({ source: values, keys: SHARED_FIELD_KEYS });

  if (organizationType === PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY) {
    return {
      organizationType,
      ...sharedValues,
      ...pickFields({ source: values, keys: AGENCY_ONLY_FIELD_KEYS }),
    };
  }

  return {
    organizationType,
    ...sharedValues,
    ...pickFields({ source: values, keys: BRAND_ONLY_FIELD_KEYS }),
  };
};
